import { render, staticRenderFns } from "./formalizacion-formato1-snp.vue?vue&type=template&id=242b4bd6&scoped=true&"
import script from "./formalizacion-formato1-snp.component.ts?vue&type=script&lang=ts&"
export * from "./formalizacion-formato1-snp.component.ts?vue&type=script&lang=ts&"
import style0 from "./formalizacion-formato1-snp.vue?vue&type=style&index=0&id=242b4bd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242b4bd6",
  null
  
)

export default component.exports